import { zodSortField } from "@/lib/utils";
import { z } from "zod";

const commercialProtocolSchema = z.enum(["CAR", "CAR3"]);

export const deleteBodyworkerProtocolListSchema = z.object({
  id: z.number(),
});

export const getBodyworkerProtocolListsRequestSchema = z.object({
  sort: zodSortField(["commercialDenomination", "kvps", "postalCode"]),
});

export const addBodyworkerProtocolListSchema = z.object({
  kvps: z
    .string()
    .regex(
      /^FRA\d{5}[A-Za-z]$/,
      "Le format KVPS est invalide (attendu: FRAxxxxxm)",
    ),
  commercialDenomination: z
    .string()
    .min(1, "La dénomination commerciale est requise")
    .max(200, "Maximum de caractères atteint"),
  postalCode: z.string().regex(/^\d{5}$/, "Le code postal est incohérent"),
  siren: z.string().regex(/^\d{9}$/, "Le n° SIREN est incohérent"),
  commercialProtocol: commercialProtocolSchema,
});

export const editBodyworkerProtocolListSchema = z.object({
  id: z.number().optional(),
  kvps: z
    .string()
    .regex(
      /^FRA\d{5}[A-Za-z]$/,
      "Le format KVPS est invalide (attendu: FRAxxxxxm)",
    ),
  commercialDenomination: z
    .string()
    .min(1, "La dénomination commerciale est requise")
    .max(200, "Maximum de caractères atteint"),
  postalCode: z.string().regex(/^\d{5}$/, "Le code postal est incohérent"),
  siren: z.string().regex(/^\d{9}$/, "Le n° SIREN est incohérent"),
  commercialProtocol: commercialProtocolSchema,
  isActive: z.boolean().default(true),
});
